// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fc9a13c9","453":"5d70a79a","455":"6311159a"}[chunkId] + ".chunk.js";
};